import { useEffect } from 'react';

function useFavicon(url: string) {
  useEffect(() => {
    if (!url) return;

    let link: HTMLLinkElement | null = document.querySelector("link[rel~='icon']");

    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    link.href = url;
  }, [url]);
}

export default useFavicon;
